import { gql } from 'apollo-boost';
import { useMutation } from '../';

const query = gql`
mutation updateNpoAnswer (
  $id: Int!,
  $questionId: Int!,
  $reportId: Int,
  $text: String,
  $answerId: Int,
  $answerErrors: Int,
  $answerWarnings: Int,
  $timeOnQuestions: Int
  $date1: Date,
  $date2: Date,
  $questionText: String,
  $investmentId: Int,
  $programId: Int,
  $orgYear: Int,
  $resourceId: Int,
  $ignoreClearData: Boolean,
) {
  updateNpoAnswer (
  id: $id,
  questionId: $questionId,
  reportId: $reportId,
  text: $text,
  answerId: $answerId,
  answerErrors: $answerErrors,
  answerWarnings: $answerWarnings,
  timeOnQuestions: $timeOnQuestions,
  date1: $date1,
  date2: $date2,
  questionText: $questionText,
  investmentId: $investmentId,
  programId: $programId,
  orgYear: $orgYear,
  resourceId: $resourceId,
  ignoreClearData: $ignoreClearData
) {
    id
    success
    nextQuestion
  }
}
`;

const queryInvestment = gql`
mutation updateNpoAnswer (
  $id: Int!,
  $questionId: Int!,
  $text: String,
  $answerId: Int,
  $answerErrors: Int,
  $answerWarnings: Int,
  $timeOnQuestions: Int
  $date1: Date,
  $date2: Date,
  $questionText: String,
  $investmentId: Int,
  $programId: Int,
  $orgYear: Int,
  $resourceId: Int
) {
  updateNpoAnswer (
  id: $id,
  questionId: $questionId,
  text: $text,
  answerId: $answerId,
  answerErrors: $answerErrors,
  answerWarnings: $answerWarnings,
  timeOnQuestions: $timeOnQuestions,
  date1: $date1,
  date2: $date2,
  questionText: $questionText,
  investmentId: $investmentId,
  programId: $programId,
  orgYear: $orgYear,
  resourceId: $resourceId
) {
    id
    success
    nextQuestion
  }
}
`;

export function useUpdateNpoAnswer() {
  const { data, isLoading, mutate } = useMutation();
  const run = (variables, onFinish) => {
    try {
      const queryToRun = variables.reportId
        ? query
        : queryInvestment;
      mutate(queryToRun, variables, (response) => {
        if (typeof onFinish === 'function') {
          onFinish(response.updateNpoAnswer.id, response.updateNpoAnswer.nextQuestion);
        }
      });
    } catch (err) {
      console.error(err);
    }
  };
  return { data, isLoading, run };
}
